/* eslint-disable @typescript-eslint/no-explicit-any */
import { EditableComponent } from '@adobe/aem-react-editable-components';
import featuredPropertiesMockMock from './__mock__/mock.json';
import { StyledFeaturedProperties } from './FeaturedProperties.styles';
/* eslint-disable @nx/enforce-module-boundaries */
import { CardCarouselContainer, CardLayeredVariations } from '@marriott/mi-ui-library';
import {
  fullbleedClass,
  IMAGE_URL_DOMAIN,
  // searchByGeoLocation,
  // searchByLocation,
  // searchByMarsha,
} from '../../modules/utils/constants/constants';
import {
  // createContext,
  useContext,
  useEffect,
  // useMemo,
  useRef,
  useState,
} from 'react';
// import Cookies from 'js-cookie';
// import { useLazyQuery } from '@apollo/client';
// import {
//   searchPropertiesByMarsha,
//   searchPropertiesByLocation,
//   searchPropertiesByGeoLocation,
// } from '@marriott/mi-awp-graphql';
import { PageParamsContext } from '../../modules/context/PageContext';
import clsx from 'clsx';
import { getHotelsUrl } from '../../modules/utils';

const { NEXT_PUBLIC_AEM_SITE } = process.env;

export const FeaturedProperties = (props: any) => {
  const { currentLocale } = useContext(PageParamsContext);
  // const pageContext = useContext(createContext<any>({}));
  // const requestId = useMemo(() => {
  //   return pageContext.requestId;
  // }, [pageContext]);
  // const sessionID = Cookies.get('sessionID');
  // const currentTimestamp = Date.now();
  // const currentDateTimeStamp = new Date(currentTimestamp).getTime();
  const [isComponentReady, setIsComponentReady] = useState<boolean>(false);
  const [cardCarouselProps, setCardCarouselProps] = useState<any>({});
  const containerRef = useRef<HTMLDivElement>(null);

  // let query = searchPropertiesByMarsha;

  // if (!props?.isAuthorMode) {
  //   switch (props?.searchType) {
  //     case searchByLocation:
  //       query = searchPropertiesByLocation;
  //       break;
  //     case searchByGeoLocation:
  //       query = searchPropertiesByGeoLocation;
  //       break;
  //     default:
  //       query = searchPropertiesByMarsha;
  //   }
  // }

  // const [getPropertyData, { loading, error, data }] = useLazyQuery(query);

  // useEffect(() => {
  //   if (!props?.isAuthorMode) {
  //     let searchInput = {};

  //     if (props?.searchType === searchByMarsha && props?.marshaCode) {
  //       searchInput = {
  //         search: {
  //           ids: props?.marshaCode?.split(','),
  //         },
  //         limit: props?.cardCount,
  //       };
  //     } else if (props?.searchType === searchByLocation && props?.filterType && props?.filterDimensions) {
  //       searchInput = {
  //         search: {
  //           facets: {
  //             terms: [
  //               {
  //                 type: props?.filterType,
  //                 dimensions: props?.filterDimensions?.split(','),
  //               },
  //             ],
  //           },
  //           options: { numberInParty: 1 },
  //         },
  //         limit: props?.cardCount,
  //       };
  //     } else if (props?.searchType === searchByGeoLocation && props?.latitude && props?.longitude) {
  //       searchInput = {
  //         search: {
  //           latitude: props?.latitude,
  //           longitude: props?.longitude,
  //         },
  //         limit: props?.cardCount,
  //       };
  //     }

  //     getPropertyData({
  //       fetchPolicy: 'network-only',
  //       ssr: false,
  //       errorPolicy: 'all',
  //       variables: searchInput,
  //       context: {
  //         headers: {
  //           'accept-language': currentLocale?.replace('_', '-') ?? 'en-US',
  //           'x-request-id': requestId,
  //           'x-b3-traceId': `${sessionID ?? sessionID ?? 'fallback-token'} - ${currentDateTimeStamp}`,
  //           'x-b3-spanId': requestId !== '' ? requestId : `${currentDateTimeStamp}`,
  //           'correlation-id': `${sessionID ?? sessionID ?? 'fallback-token'} - ${currentDateTimeStamp}`,
  //         },
  //       },
  //     });
  //   }
  // }, [
  //   props?.searchType,
  //   props?.marshaCode,
  //   props?.filterType,
  //   props?.filterDimensions,
  //   props?.latitude,
  //   props?.longitude,
  //   currentLocale,
  //   props?.isAuthorMode,
  // ]);

  useEffect(() => {
    generateCarouselProps(featuredPropertiesMockMock?.data?.search?.properties?.searchByPropertyIds?.edges);
  }, []);

  // useEffect(() => {
  //   let searchData;
  //   switch (props?.searchType) {
  //     case searchByLocation:
  //       searchData = data?.search?.properties?.searchByLocation?.edges;
  //       break;
  //     case searchByGeoLocation:
  //       searchData = data?.search?.properties?.searchByGeolocation?.edges;
  //       break;
  //     default:
  //       searchData = data?.search?.properties?.searchByPropertyIds?.edges;
  //       break;
  //   }

  //   if (searchData?.length > 0) {
  //     let hotelsList = searchData;
  //     hotelsList = hotelsList?.filter((hotel: any) =>
  //       props?.cardVariation === CardLayeredVariations?.Tall
  //         ? hotel?.node?.media?.primaryImage?.edges?.[0]?.node?.imageUrls?.classicVertical !== null &&
  //           hotel?.node?.media?.primaryImage !== null
  //         : hotel?.node?.media?.primaryImage?.edges?.[0]?.node?.imageUrls?.square !== null &&
  //           hotel?.node?.media?.primaryImage !== null
  //     );
  //     generateCarouselProps(
  //       hotelsList?.length > props?.cardCount ? hotelsList?.slice(0, props?.cardCount) : hotelsList
  //     );
  //   } else if (error && !data) {
  //     setIsComponentReady(false);
  //   }
  // }, [data, error]);

  const generateCarouselProps = (hotelsData: any) => {
    const cqItems = hotelsData?.map((hotel: any) => {
      const dynamicMedia =
        props?.cardVariation === CardLayeredVariations?.Tall
          ? 'dynamicMediaTall'
          : props?.cardVariation === CardLayeredVariations?.Wide
          ? 'dynamicMediaWide'
          : 'dynamicMedia';
      return {
        ':items': {
          [props.cardTypes]: {
            ':type': `mi-aem-common-spa/components/content/${props.cardTypes}`,
            headerTag: 'h3',
            styleclass: props?.cardsStyleClass,
            ctaLink: getHotelsUrl(hotel?.node, currentLocale),
            eyebrow:
              hotel?.node?.contactInformation?.address?.stateProvince?.description ||
              hotel?.node?.contactInformation?.address?.city,
            header: hotel?.node?.basicInformation?.name || '',
            fontSize: 't-subtitle-l',
            openInNewTab: props?.cardLinkIsOpenInNewTab,
            cardLayeredVariations: props?.cardVariation,
            [dynamicMedia]: {
              renditionUrl: null,
              altText: hotel?.node?.media?.primaryImage?.edges?.[0]?.node?.alternateDescription || '',
              assetPath:
                props?.cardVariation === CardLayeredVariations?.Square
                  ? IMAGE_URL_DOMAIN + hotel?.node?.media?.primaryImage?.edges?.[0]?.node?.imageUrls?.square || ''
                  : IMAGE_URL_DOMAIN + hotel?.node?.media?.primaryImage?.edges?.[0]?.node?.imageUrls?.classicVertical ||
                    '',
              enableSmartCrop: true,
              dynamic: false,
              renditions: [],
              damPath:
                props?.cardVariation === CardLayeredVariations?.Square
                  ? IMAGE_URL_DOMAIN + hotel?.node?.media?.primaryImage?.edges?.[0]?.node?.imageUrls?.square || ''
                  : IMAGE_URL_DOMAIN + hotel?.node?.media?.primaryImage?.edges?.[0]?.node?.imageUrls?.classicVertical ||
                    '',
            },
            logoIcon: hotel?.node?.basicInformation?.brand?.id,
            logoIconAltText: hotel?.node?.basicInformation?.brand?.name || '',
          },
        },
      };
    });

    const cqItemsList = Object.fromEntries(cqItems.map((item: any, key: number) => [`card-${key}`, item]));
    const updatedProps = {
      ...props?.model,
      cqItems: cqItemsList,
      cqItemsOrder: Object.keys(cqItemsList),
      totalNumberOfCards: Object.keys(cqItemsList),
      cardCount: hotelsData?.length,
      styleclass: props?.styleclass?.includes(fullbleedClass) ? fullbleedClass : '',
      isAuthorMode: false,
      allowedComponents: props?.allowedComponents,
    };
    setCardCarouselProps(updatedProps);
    if (
      ((props?.cardVariation === CardLayeredVariations?.Square && hotelsData?.length > 1) ||
        (props?.cardVariation !== CardLayeredVariations?.Square && hotelsData?.length > 2)) &&
      Object.keys(updatedProps)?.length > 0
    ) {
      setIsComponentReady(true);
    } else setIsComponentReady(false);
  };

  useEffect(() => {
    if (props?.cardVariation !== CardLayeredVariations?.Square || !containerRef.current) return;
    const container = containerRef.current;

    let isCarouselControlUpdated = false;
    let areCardTextsUpdated = false;

    const applyClassUpdates = () => {
      if (!isCarouselControlUpdated) {
        const carouselDiv = container.querySelector('.center-align .carouselControlType1');
        if (carouselDiv) {
          carouselDiv.classList.remove('carouselControlType1');
          carouselDiv.classList.add('carouselControlType3b');
          isCarouselControlUpdated = true;
        }
      }

      if (!areCardTextsUpdated) {
        const cardTextNodes = container.querySelectorAll('.card-layered__content .card-texts');

        if (cardTextNodes.length > 0) {
          cardTextNodes.forEach((cardTextNode, index) => {
            cardTextNode.classList.add(
              `brand-logo-${cardCarouselProps?.cqItems?.[`card-${index}`]?.[':items']?.cardlayered?.logoIcon}`
            );
          });
          areCardTextsUpdated = true;
        }
      }

      return isCarouselControlUpdated && areCardTextsUpdated;
    };

    if (applyClassUpdates()) return;

    // Element not yet rendered by child; observe until all updates can be applied.
    const observer = new MutationObserver(() => {
      try {
        if (applyClassUpdates()) observer.disconnect();
      } catch (err) {
        observer.disconnect();
      }
    });
    observer.observe(container, { childList: true, subtree: true });
    return () => observer.disconnect();
  }, [cardCarouselProps]);

  // if (loading) return <div className={clsx('m-spinner-m')} data-testid="map-loader"></div>;

  if (isComponentReady)
    return (
      <StyledFeaturedProperties ref={containerRef} className={props?.styleclass} id={`${props?.componentId}-container`}>
        <div
          className={clsx('container', props?.cardVariation === CardLayeredVariations?.Square ? 'card-up-header' : '')}
        >
          <CardCarouselContainer {...cardCarouselProps} />
        </div>
      </StyledFeaturedProperties>
    );
  else return null;
};

export const FeaturedPropertiesConfig = {
  emptyLabel: 'Featured Properties',
  isEmpty: false,
  resourceType: `${NEXT_PUBLIC_AEM_SITE}/components/content/traveler/featuredproperties`,
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const FeaturedPropertiesEditable = (props: any) => (
  <EditableComponent config={FeaturedPropertiesConfig} {...props}>
    <FeaturedProperties {...props} />
  </EditableComponent>
);
